class TextFlipper extends HTMLElement {
	constructor() {
		super();

		this.container = this;

		let options = {
			speed: parseInt(this.dataset.speed),
			minFlips: parseInt(this.dataset.minflips),
			maxFlips: parseInt(this.dataset.maxflips),
			background: this.dataset.background,
			darkColor: this.dataset.darkcolor
		}

		// Use IntersectionObserver to only run the text flipper once the browser has scrolled the section into view.
		const _this = this;
		let parentContainer = this.parentElement;
		const observer = new IntersectionObserver(handleIntersection);
		observer.observe(parentContainer);

		function handleIntersection(entries, observer) {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					_this.listeners(options);
					// Unobserve ensures the animation only runs once per element
					observer.unobserve(entry.target);
				}
			});
		}
	}

	listeners(options) {
		this.container.classList.add('text-flipper--active');

		this.options = {
			speed: options.speed ? options.speed : 130,
			minFlips: options.minFlips ? options.minFlips : 1,
			maxFlips: options.maxFlips ? options.maxFlips : 10,
			darkColor: options.darkColor ? options.darkColor : '#555',
			background: options.background ? options.background : '#1d1d1d',
			autoPlay: options.autoPlay ? options.autoPlay : true,
		}

		this.ui();
		this.chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
			'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X',
			'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', ' ', '&', "'", "!", '"', '?', '.', ',', ':'];
		this.end = this.getString();
		this.checkMissing();
		this.begin = this.jumble();
		this.words = this.end.toUpperCase().split(/(\s)/);
		this.count = this.end.length;

		this.now;
		this.then = Date.now();
		this.elapsed;
		this.track = [];

		this.index = 0;
		this.offset = Math.floor(this.count / 2);

		this.init();
		this.bindEvents();
	}


	ui() {
		let fs = window.getComputedStyle(this.container, null).getPropertyValue('font-size');
		this.container.style.setProperty('--tf-size', fs);
		this.container.style.setProperty('--tf-rad', (parseFloat(fs) / 15) + "px");
		this.container.style.setProperty('--tf-bg', this.options.background);
		this.container.style.setProperty('--tf-bottom', this.options.darkColor);
	}

	getString() {
		return this.container.innerText.toUpperCase();
	}

	jumble() {
		let res = "";
		let temp = this.end.split("")
		for (let i of temp) {
			let p = this.chars.indexOf(i);
			let rand = Math.floor(Math.random() * (this.options.maxFlips - this.options.minFlips + 1)) + this.options.minFlips;
			(p - rand) < 0 ? p = this.chars.length - p : 0;
			res += this.chars[p - rand];
		}
		return res;
	}

	checkMissing() {
		for (let c of this.end.split("")) this.chars.indexOf(c.toUpperCase()) < 0 ? this.chars.push(c.toUpperCase()) : 0;
	}

	bindEvents() {
		window.addEventListener('resize', this.resize.bind(this));
	}

	resize() {
		for (let _c of this._collapse) {
			_c.style.display = 'flex';
			if((_c.offsetLeft - _c.parentNode.offsetLeft) <= 0) {
				_c.style.display = 'none';
			}
		}
		this.ui();
	}

	init() {
		let html = "<div class='word'>";
		let currentWord = 0;
		let ind = 0;
		this.num = [];
		this.flag = [];
		for (let i = 0; i < this.count; i++) {
			html += '<div class=splitflap><div class="top"></div><div class="bottom"></div><div class="nextHalf"></div><div class="nextFull"></div></div>';
			ind++;
			if (ind == this.words[currentWord].length) {
				currentWord++;
				ind = 0;
				html += "</div><div class='word'>";
			}
			this.num[i] = this.chars.indexOf(this.begin[i]);
			this.flag[i] = false
		}
		html += "</div>";
		this.container.innerHTML = html;
		let _words = [...this.container.querySelectorAll('.word')];
		for (let i = 0; i < _words.length; i++) {
			if (_words[i].children.length == 1) {
				if (this.words[i] == " ") {
					_words[i].classList.add('collapse');
				}
			}
		}
		this._collapse = [...this.container.querySelectorAll('.collapse')];
		this.a1 = [...this.container.querySelectorAll(".top")];
		this.a2 = [...this.container.querySelectorAll(".bottom")];
		this.b1 = [...this.container.querySelectorAll(".nextFull")];
		this.b2 = [...this.container.querySelectorAll(".nextHalf")];
		for (let i = 0; i < this.a1.length; i++) {
			this.a2[i].style.animationDuration = this.options.speed / 1100 + "s";
			this.b2[i].style.animationDuration = this.options.speed / 1100 + "s";
		}
		this.resize();

		for (let f = 0; f < this.count; f++) {
			this.a1[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
			this.a2[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
			this.b1[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
			this.b2[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
		}
		if (this.options.autoPlay) this.run();
	}

	run() {
		this.now = Date.now();
		this.elapsed = this.now - this.then;

		if (this.elapsed > this.options.speed) {
			this.then = this.now - (this.elapsed % this.options.speed);
			for (let i = 0; i < this.count; i++) {
				if (this.track[i] == this.end[i]) {
					this.noFlip(i);
				} else {
					this.flip(i)
				};
			}
			if (this.flag.every(function (e) { return e })) return;
		}

		requestAnimationFrame(this.run.bind(this));
	}

	flip(f) {
		this.a1[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
		this.a2[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
		this.b1[f].innerHTML = this.chars[this.num[f]];
		this.track[f] = this.chars[this.num[f]];
		this.b2[f].innerHTML = this.chars[this.num[f]];
		this.a2[f].classList.remove("flip1");
		void (this.a2[f].offsetWidth);
		this.a2[f].classList.add("flip1");
		this.num[f] > this.chars.length - 2 ? this.num[f] = 0 : this.num[f]++;
	}

	noFlip(f) {
		this.flag[f] = true;
		this.a1[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
		this.a2[f].innerHTML = this.chars[(this.num[f] == 0) ? this.chars.length - 1 : this.num[f] - 1];
	}
}

customElements.define('text-flipper', TextFlipper);